<template>
  <div v-if="feats.length > 0" class="feats">
    <div class="h4 title">Особенности</div>
    <div class="list">
      <div v-for="feat in feats" :key="feat" class="item">
        <Icon icon="feats" />
        <span v-html="list ? feat : translate[feat]" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: null,
    },
    properties: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      translate: {
        view_from_window: "Виды из окон",
        with_balcony: "Наличие балкона",
        with_decoration: "Наличие отделки",
        with_decoration_whitebox: "Возможна отделка White Box",
        with_terrace: "Наличие террасы",
        with_large_bathroom: "Квартира с большой ванной комнатой",
        euroformat: "Квартира евроформата",
        master_bedroom: "Мастер-спальня",
        two_bathrooms_and_more: "2 ванные комнаты и более",
        view_botanical_garden: "Вид на Ботанический сад",
        view_ostankino_park: "Вид на парк Останкино",
        view_small_botanical_garden: "Вид на малый ботанический сад",
        multispace: "Мультипространство (без несущих стен)",
        vestibule_without_transit_ways: "Прихожая без транзитных путей",
        checkroom: "Гардеробная",
        panoramic_windows: "Панорамные окна",
        windows_on_2_sides: "Окна на 2 стороны света",
        view_intersection_park_areas: "Вид на пересечение парковых зон",
        increased_number_windows: "Увеличенное кол-во окон",
        mortgage_percent: "Особенные условия по ипотеки %",
        design_with_furnishings: "Дизайнерская отделка с меблировкой",
      },
    };
  },
  computed: {
    feats() {
      if (this.list) {
        return this.list;
      }
      const list = Object.keys(this.properties).filter((key) => {
        return this.properties[key] && this.translate[key];
      });
      return list;
    },
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 10px;
}

.list {
  font-weight: normal;
  font-size: 18px;
}

.item {
  position: relative;
  padding: 15px 0 15px 25px;
  border-bottom: 1px solid #e5e5e5;
}

.item > span {
  font-weight: 700;
}

.item:last-child {
  border-bottom: 0;
}

.item .icon-feats {
  position: absolute;
  top: 19px;
  left: 0;
}

@media (max-width: 767px) {
  .list {
    font-size: 16px;
  }
  .item {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .item .icon-feats {
    top: 13px;
  }
}
</style>
